// import { useCallback } from 'react'
// import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import GalleriesMenu from './GalleriesMenu'

import { getCurrentPromocion } from '../../modules/reducerPromocion'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const PromotionGalleriesMenu = () => {
  const promocion = useSelector(getCurrentPromocion)
  // const dispatch = useDispatch()
  // const classes = useStyles()
  return promocion ? <GalleriesMenu galleriesIds={promocion.galleries} /> : null
}
export default PromotionGalleriesMenu
